import API from ".";

export const generatePortfolioSummary = async (filters: any) => {
  try {
    const fromDate = filters.fromDate ?? "";
    const toDate = filters.toDate ?? "";
    const period = filters.periodWithOutDay ?? "";
    const state = filters.state ?? "";
    const territory = filters.territory ?? "";
    const cluster = filters.cluster ?? "";
    const branch = filters.branch ?? "";

    const response = await API.get(`generate/portfolio_summary/list?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}&product_type=W`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};


export const generatePortfolioSummaryOverAll = async (filters: any) => {
  try {
    const fromDate = filters.fromDate ?? "";
    const toDate = filters.toDate ?? "";
    const period = filters.periodWithOutDay ?? "";
    const state = filters.state ?? "";
    const territory = filters.territory ?? "";
    const cluster = filters.cluster ?? "";
    const branch = filters.branch ?? "";

    const response = await API.get(`generate/portfolio_summary/list?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}&product_type=`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};


export const generatePortfolioMovement = async (filters: any) => {
    try {
      const fromDate = filters.fromDate ?? "";
      const toDate = filters.toDate ?? "";
      const period = filters.periodWithOutDay ?? "";
      const state = filters.state ?? "";
      const territory = filters.territory ?? "";
      const cluster = filters.cluster ?? "";
      const branch = filters.branch ?? "";
  
      const response = await API.get(`generate/portfolio_summary/list_principal_net_moment?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };

  export const generatePortfolioSummaryEWI = async (filters: any) => {
    try {
      const fromDate = filters.fromDate ?? "";
      const toDate = filters.toDate ?? "";
      const period = filters.periodWithOutDay ?? "";
      const state = filters.state ?? "";
      const territory = filters.territory ?? "";
      const cluster = filters.cluster ?? "";
      const branch = filters.branch ?? "";
  
      const response = await API.get(`generate/portfolio_summary/ewi_list?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };
  
  
  export const generatePortfolioMovementEWI = async (filters: any) => {
      try {
        const fromDate = filters.fromDate ?? "";
        const toDate = filters.toDate ?? "";
        const period = filters.periodWithOutDay ?? "";
        const state = filters.state ?? "";
        const territory = filters.territory ?? "";
        const cluster = filters.cluster ?? "";
        const branch = filters.branch ?? "";
    
        const response = await API.get(`generate/portfolio_summary/list_principal_net_moment_ewi?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
        return response.data;
      } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
      }
    };


    export const generateDeliquencyLinechart = async (filters: any) => {
      try {
        const fromDate = filters.fromDate ?? "";
        const toDate = filters.toDate ?? "";
        const period = filters.periodWithOutDay ?? "";
        const state = filters.state ?? "";
        const territory = filters.territory ?? "";
        const cluster = filters.cluster ?? "";
        const branch = filters.branch ?? "";
    
        const response = await API.get(`generate/portfolio_delinquency/list_percentage_coincidental_ewi?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
        return response.data;
      } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
      }
    };


